export default __webpack_public_path__ + "static/media/nftvi.f7030175.gif";